import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGrid } from "@fortawesome/pro-solid-svg-icons";
import { Popover } from "@headlessui/react";
import { NavLink } from "react-router-dom";
import { t } from "i18next";
import { useModules } from "../hooks/useModules";
import { getLocatorValue } from "../../pointOfSale/utils/Misc";
import { useAdminSelector } from "../../../stores/AdminStore";

export const ModulePopover = () => {
  const modules = useModules();
  const { selectedProduct } = useAdminSelector((s) => s.pos);

  const handleModuleClick = (
    name: string,
    close: () => void,
    event: React.MouseEvent
  ) => {
    if (name === "Kitchen Display System") {
      event.preventDefault();
      window.open(import.meta.env.VITE_KDS_APP_URL);
    } else {
      close();
    }
  };

  return (
    <Popover>
      <Popover.Button
        className="w-8 h-8 md:w-14 md:h-14 text-2xl md:text-4xl
        flex justify-center items-center select-none text-unleashed-yellow"
        title={t`Applications`}
        disabled={selectedProduct !== undefined}
      >
        <FontAwesomeIcon
          icon={faGrid}
          className={`${
            selectedProduct !== undefined
              ? "text-gray-400 cursor-not-allowed"
              : ""
          }`}
        />
      </Popover.Button>
      <Popover.Panel
        className="absolute z-40 right-0 w-full md:w-96 bg-white
        text-black border border-gray-400"
      >
        {({ close }) => (
          <div className="flex flex-wrap p-2">
            {modules.map((a, i) => (
              <div key={i} className="w-1/4 p-2">
                <NavLink
                  data-cy-module-name={getLocatorValue(a.name)}
                  to={a.path}
                  className="group"
                  onClick={(event) => handleModuleClick(a.name, close, event)}
                >
                  <div className="flex justify-center w-full">
                    <div
                      className="h-14 w-14 text-white flex justify-center
                        items-center text-4xl rounded"
                      style={{ background: a.color }}
                    >
                      {a.image ? (
                        <img src={a.image} alt={a.name} className="h-12 w-12" />
                      ) : (
                        a.icon && <FontAwesomeIcon icon={a.icon} />
                      )}
                    </div>
                  </div>
                  <div
                    className="text-xs text-center text-gray-500
                      group-hover:text-unleashed-pink underline mt-1"
                  >
                    {a.name}
                  </div>
                </NavLink>
              </div>
            ))}
          </div>
        )}
      </Popover.Panel>
    </Popover>
  );
};
